import { render, staticRenderFns } from "./AddChannelFeeitem.vue?vue&type=template&id=e4abca92"
import script from "./AddChannelFeeitem.vue?vue&type=script&lang=js"
export * from "./AddChannelFeeitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports